import { createSlice } from '@reduxjs/toolkit';
import { SupportedLanguage, supportedLanguages } from '../utils/languageHelper';
import { parseJSON } from '../utils/jsonParser';
import i18n from '../../i18n';

export interface MealItemListState {
  selectedLanguage: SupportedLanguage;
}

const initialState: MealItemListState = {
  selectedLanguage:
    parseJSON(localStorage.getItem('language')) ?? supportedLanguages.get(0)!,
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setDefaultLanguage: (state) => {
      const localStorageSelectedLanguage = parseJSON(
        localStorage.getItem('language')
      );
      if (localStorageSelectedLanguage) {
        return;
      }
      const selectedLanguage: SupportedLanguage = supportedLanguages.get(0)!;
      state.selectedLanguage = selectedLanguage;
      i18n.changeLanguage(selectedLanguage.culture);
      localStorage.setItem('language', JSON.stringify(selectedLanguage));
      // Trigger page reload
      window.location.reload();
    },
    selectLanguage: (state, action) => {
      const selectedLanguage: SupportedLanguage = action.payload;
      state.selectedLanguage = selectedLanguage;
      i18n.changeLanguage(selectedLanguage.culture);
      localStorage.setItem('language', JSON.stringify(selectedLanguage));
      // Trigger page reload
      window.location.reload();
    },
  },
});

export const { selectLanguage, setDefaultLanguage } = languageSlice.actions;
